const state = {
    YieldValidation: null,
    SurfaceValidation: null,
    CropStage: null,
    CropType: null,
    CropCultures: null,
    CropStageFruitValidation: false,

    // Show Dropdown
    ActiveDropDown: false,

    // Hide yes/no buttons for additional parameters
    DisableBtnAdditonal: false
};

const getters = {
    cropTypeValidation: state => {
        return state.CropType;
    },
    cropCulturesValidation: state => {
        return state.CropCultures;
    },
    cropStageValidation: state => {
        return state.CropStage;
    },
    yieldValidation: state => {
        return state.YieldValidation;
    },
    surfaceValidation: state => {
        return state.SurfaceValidation;
    },
    cropStageFruitValidation: state => {
        return state.CropStageFruitValidation;
    },
    activeDropDown: state => {
        return state.ActiveDropDown;
    },
    disableBtnAdditonal: state => {
        return state.DisableBtnAdditonal;
    }
};

const mutations = {
    UpdateCropTypeValidation: (state, payload) => {
        state.CropType = payload;
    },
    UpdateCropStageValidation: (state, payload) => {
        state.CropStage = payload;
    },
    UpdateCropCulturesValidation: (state, payload) => {
        state.CropCultures = payload;
    },
    UpdateYieldValidation: (state, payload) => {
        state.YieldValidation = payload;
    },
    UpdateSurfaceValidation: (state, payload) => {
        state.SurfaceValidation = payload;
    },
    UpdateCropStageFruitValidation: (state, payload) => {
        state.CropStageFruitValidation = payload;
    },
    UpdateActiveDropDown: (state, payload) => {
        state.ActiveDropDown = payload;
    },
    UpdateDisableBtnAdditonal: (state, payload) => {
        state.DisableBtnAdditonal = payload;
    }
};

const actions = {
    UpdateCropTypeValidation({ commit }, payload) {
        commit('UpdateCropTypeValidation', payload);
    },
    UpdateCropCulturesValidation({ commit }, payload) {
        commit('UpdateCropCulturesValidation', payload);
    },
    UpdateCropStageValidation({ commit }, payload) {
        commit('UpdateCropStageValidation', payload);
    },
    UpdateYieldValidation({ commit }, payload) {
        commit('UpdateYieldValidation', payload);
    },
    UpdateSurfaceValidation({ commit }, payload) {
        commit('UpdateSurfaceValidation', payload);
    },
    UpdateCropStageFruitValidation({ commit }, payload) {
        commit('UpdateCropStageFruitValidation', payload);
    },
    UpdateActiveDropDown({ commit }, payload) {
        commit('UpdateActiveDropDown', payload);
    },
    UpdateDisableBtnAdditonal({ commit }, payload) {
        commit('UpdateDisableBtnAdditonal', payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
